import FaqDetails from "./component"

import React, { useEffect ,useState} from "react";

import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import logger from "../../Utils/logger";
const FaqDetailsContainer=(props)=>{
  const navigate=useNavigate()
  const { makeApiRequest } = useApiRequest()
  const [orderhistory,setOrderhistory]=useState('')
const [loader,setLoader]=useState(true);
const [topicDetailsList,seTopicDetailsList]=useState([])
const {topicId} =useParams()


    useEffect(()=>{
        FaqDetailsApi()
       
    },[])
    const FaqDetailsApi=()=>{

        const UserJWTAuth = localStorage.getItem("UserJWTAuth");


           makeApiRequest({
       
        url: `${process.env.REACT_APP_API_BASE_URL}/support/api/v2/faq/topic/${topicId}`,
      method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
        },
        data:{
    
        request:{}


      },
      handleSuccess: (res) => handleResponseFaqDetails(res),
      handleError:(error)=> handleErrorFaqDetails(error),
    });
    
      }
    
      const handleErrorFaqDetails=(error)=>{
        //logger.log("res")
        setLoader(false)
        if(error.response.status==401|| error.response.status==403){

         // logger.log("khan handleErrorVmInventory", error.response.data.status.code);
          //Logout
          //localStorage.removeItem("UserJWTAuth")
          navigate("/login");
      }
      else{ toast.error(`${error.response.data.status.code}`, {
        position: "top-right",
        autoClose: 1000,
      });
      }


        
      }
      
      const  handleResponseFaqDetails=(res)=>{
        logger.log("handleResponseFaqDetails-------" )
        seTopicDetailsList(res.data.data)
        setLoader(false)
        
      }








    return(<>
    
    <FaqDetails 
    topicDetailsList={topicDetailsList}/>
    
    </>)
}



export default FaqDetailsContainer
